import React from 'react';
import { HeartIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { ProductImage } from '../ProductImage';
import { BRAND, OFFER_SECTION_ID, PRODUCT_NAME } from '../../data/salesContent';
export function HeroSection() {
  return <header className="border-b border-line bg-cream px-5 pb-16 pt-6 md:pb-24 md:pt-10" data-id="element-131" data-mp="21cfluyd9rp9g">
      <div className="mx-auto max-w-6xl" data-id="element-132" data-mp="1x8hn4oruwggx">
        <p className="flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-[0.25em] text-ink lg:justify-start" data-id="element-133" data-mp="1s9ei34bvma8y">
          <HeartIcon className="h-4 w-4 fill-rose text-rose" aria-hidden="true" data-id="element-134" data-mp="1ni66c1n2qcsm" />
          {BRAND}
        </p>
        <div className="mt-6 grid items-center gap-x-14 gap-y-6 md:mt-12 lg:grid-cols-[1.05fr_1fr]" data-id="element-135" data-mp="1iked94ap0kmu">
          <div className="text-center lg:col-start-1 lg:row-start-1 lg:self-end lg:text-left" data-id="element-136" data-mp="1dmctsi9cujau">
            <p className="text-sm font-semibold uppercase tracking-[0.12em] text-rose-dark md:text-base" data-id="element-137" data-mp="19inbubn6qzys">
              ¿Es tu primer bebé o sentís que tenés mil preguntas?
            </p>
            <h1 className="mt-4 font-serif text-[1.75rem] uppercase leading-[1.12] text-ink sm:text-5xl lg:text-[3.25rem]" data-id="element-138" data-mp="31nciq3mfsq9o">
              Preparate para sus primeros 90 días con <span className="text-rose-dark" data-id="element-139" data-mp="2snzj02o47g25">más claridad y organización.</span>
            </h1>
          </div>

          <ProductImage className="mx-auto w-full max-w-[300px] sm:max-w-md lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:max-w-xl" data-id="element-140" data-mp="2wo9prhjqeai2" />

          <div className="text-center lg:col-start-1 lg:row-start-2 lg:self-start lg:text-left" data-id="element-141" data-mp="3kff1bkin2gmk">
            <p className="font-serif text-xl uppercase text-ink md:text-2xl" data-id="element-142" data-mp="3pcxddjrydbys">{PRODUCT_NAME}</p>
            <p className="mt-1 text-sm font-bold uppercase tracking-[0.15em] text-honey-dark" data-id="element-143" data-mp="3bdfnf12x7snu">5 volúmenes + 4 bonos exclusivos</p>
            <div className="mt-6" data-id="element-144" data-mp="3gev3eeq8r8zd">
              <CtaButton scrollToId={OFFER_SECTION_ID} note="100% digital · Acceso inmediato · Material de consulta e imprimible" data-id="element-145" data-mp="1zyird78bk36z">
                Quiero el kit completo
              </CtaButton>
            </div>
            <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-ink-muted lg:mx-0" data-id="element-146" data-mp="agbu2mkex5c0">
              Desde los preparativos para el nacimiento hasta los primeros meses en casa: encontrá guías ilustradas, consejos prácticos y herramientas de organización reunidas en un solo kit digital.
            </p>
            <p className="mx-auto mt-4 max-w-xl border-t border-line pt-4 text-sm leading-relaxed text-ink-muted lg:mx-0" data-id="element-147" data-mp="3sv4k0m7c2gh4">
              Pensado para embarazadas primerizas, madres con bebés de 0 a 3 meses y familias que buscan información clara y recursos útiles para esta nueva etapa.
            </p>
          </div>
        </div>
      </div>
    </header>;
}